<template>
<div class="mainwrap">

    <div class="tune-widget-mainbar">
        <div class="tune-widget-mainbar-l">
            <img :src="img1" class="header-image" alt="start image">
        </div>
        <div class="tune-widget-mainbar-m">{{ $t("make_an_appointment") }}</div>
        <div class="tune-widget-mainbar-r"> &nbsp;</div>
    </div>


    
        <div class="main-header" >{{ $t("make_an_appointment") }}</div>
    <div v-if="!sent" class="shop-results">
    <div style="float:left;padding:1%;">
        
  

        
    
        <!-- // Customer name -->
        <div class="generic-form-row">
            <div class="generic-form-label">{{ $t("name") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
            <div class="generic-form-value"><input type="text" class="default-input" id="customer_name" name="customer_name" placeholder="" :value="curOrder.name"></div>
        </div>
    
        <!-- // Shipping zip + city -->
        <div class="generic-form-row">
            <div class="generic-form-label">{{ $t("city") }} / {{ $t("country") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
            <div class="generic-form-value">
                <input type="text" class="default-input"  style="width:50%;" id="shipping_city" name="shipping_city" placeholder="" :value="curOrder.shipping_city">
                <div class="generic-form-value" style="float:right;line-height:2vh;width:45%;"><span v-html='renderDDLB("shipping_country", countries, curOrder.shipping_country, $t("country"))'></span></div>
            </div>
        </div>

        <!-- Phone -->
        <div class="generic-form-row">
            <div class="generic-form-label">{{ $t("phone") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
            <div class="generic-form-value"><input type="text" class="default-input" id="customer_phone" name="customer_phone" placeholder="" ></div>
        </div>

        <!-- Email address -->
        <div class="generic-form-row">
            <div class="generic-form-label">{{ $t("email") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
            <div class="generic-form-value"><input type="text" class="default-input" id="customer_email" name="customer_email" placeholder="" :value="curOrder.email" ></div>
        </div>

        <!-- // Make + MOdel + Year + Engine -->
        <div class="generic-form-row">
            <div class="generic-form-label">{{ $t("make_model_year_engine") }}</div>
            <div class="generic-form-value"><input type="text" class="default-input" placeholder="" :value="removeBR(this.fullSelectionDesc())" disabled></div>                
            <!-- <div class="generic-form-value">{{ this.fullSelectionDesc() }}</div> -->
        </div>

        <!-- // appointment_plan -->
        <div class="generic-form-row">
            <div class="generic-form-label">{{ $t("appointment_plan") }}</div>
            <div class="generic-form-value"><input type="text" class="default-input" placeholder="" :value="this.$store.state.curSelectedProduct.Category" disabled></div>
        </div>



        <!-- // License plate or VIN -->
        <div class="generic-form-row">
            <div class="generic-form-label">{{ $t("plate_or_vin") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
            <div class="generic-form-value"><input type="text" class="default-input" id="customer_platevin" name="customer_platevin" placeholder="" :value="curOrder.platevin"></div>
        </div>


       <!-- // Preferred Rica dealer -->
        <div class="generic-form-row">
            <div class="generic-form-label" style="height:auto;">{{ $t("pref_rica_loc") }}</div>
            <div class="generic-form-value"><input type="text" class="default-input" id="customer_prefloc" name="customer_prefloc" placeholder="" :value="curOrder.prefloc"></div>
        </div>

        <!-- // Additional info / notes -->
        <div class="generic-form-row">
            <div class="generic-form-label">{{ $t("additional_info") }}</div>
            <div class="generic-form-"><textarea class="default-input-textarea" style="height:150px;" id="customer_notes" name="customer_notes" placeholder=""></textarea></div>
        </div>                
        <div class="generic-form-row">&nbsp;</div>

        <div class="generic-form-row" >
            <div class="two-button-left">
          <div class="tune-action-button" @click="this.$router.push('/')">{{ $t("go_back") }}</div>
            </div>
            <div class="two-button-right">
                <div class="tune-action-button" @click="makeAppointment()">{{ $t("make_appointment") }}</div>
            </div>
        </div>

        <div class="generic-form-row"></div>

    </div>
    </div>

    <div v-if="sent" class="shop-results">

        <div class="checkout-row">&nbsp;</div>
        <div class="checkout-row" style="text-align:center;">
            <div class="" style="float:left;width:100%;">
                <div class="text-block-margin">
                    {{ $t("appointment_sent") }}
                </div>
                <div class="checkout-row">
                    <div class="checkout-field-value" ><div class="tune-action-button" style="width:200px;display:inline-block;" @click="this.$router.push('/')">{{ $t("go_back") }}</div></div>
                </div>
            </div>
        </div>



    </div>

  <transition name="modal">
    <modal v-if="showModal" @close="showModal = false">
        <template v-slot:header >
            <span v-html="curModalHeader"></span>
        </template>
        <template v-slot:body>
            <span v-html="curModalBody"  style="display:inline-block;width:360px;height:80px;"></span>
        </template>
        <template v-slot:footer>
            <button class="modal-default-button" @click="showModal = false; hideProductAction()">{{ $t("ok")}}</button>
        </template>
    </modal>
  </transition>

</div>

</template>

<script>
import axios from 'axios'

export default {
    data() {
        var countries = {};
        var curLocale = this.$i18n.locale;
        window.curStrings = this.$i18n.messages[curLocale]; 
        var apiHost =  process.env.VUE_APP_RICA_API_HOST;
        var sent = false;
        var showModal = false;
        var curModalHeader = "";
        var curModalBody = "cur body";
        var curModalFooter = "cur footer";        
        return {
            img1:require('./../assets/header-logo.png'), 
            emailIcon:require('./../assets/button-email.png'),
            phoneIcon:require('./../assets/button-contact.png'),
            locationIcon:require('./../assets/button-location.png'),           
            countries: countries,
            apiHost,
            sent,
            showModal:showModal,
            curModalHeader:curModalHeader,
            curModalBody:curModalBody,
            curModalFooter:curModalFooter
        }
    },
      computed: {
    shoppingCart: function () {
      return this.$store.state.shoppingCart;
    },
    curOrder: function () {
      return this.$store.state.curOrder;
    }},
    props:[ 'closePopup' ],
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
            if(window.parentIFrame) {
                window.parentIFrame.scrollTo(0,0);
            }            
        },        
        hideProductAction() {
            this.closePopup();
        },
        renderModal(msg) {
            this.showModal = true;
            this.curModalBody = msg;

        }, 
        fullSelectionDesc() {
             var fullDescription = "";
           console.log("this.$store.state.curMakes > " + this.$store.state.curMakes);
            // get make description
            for(var i=0 ; i < this.$store.state.curMakes.length ; i++) {
                // console.log("this.$store.state.curMakes[i].MakeID > " + this.$store.state.curMakes[i].MakeID);
                if(this.$store.state.curSelectedMake == this.$store.state.curMakes[i].MakeID) {
                    fullDescription += this.$store.state.curMakes[i].Make + " "; 
                }
            }

            // get model description
            for(var i=0 ; i < this.$store.state.curModels.length ; i++) {
                if(this.$store.state.curSelectedModel == this.$store.state.curModels[i].ModelID) {
                    fullDescription += this.$store.state.curModels[i].Model + " - ";
                }
            }

            // get variant description
            for(var i=0 ; i < this.$store.state.curVariants.length ; i++) {
                if(this.$store.state.curSelectedVariant == this.$store.state.curVariants[i].VehicleID) {
                    fullDescription += this.$store.state.curVariants[i].Description; 
                }
            }
            return  fullDescription;

        },        
        makeAppointment() {
        // validate form
            var formValid = this.validateForm();
            console.log("formValid =" + JSON.stringify(formValid["postdata"]));
            console.log("curStrings =" + JSON.stringify(curStrings));
            if(formValid["status"] == "success") {
                var par = this;
                var postvars = new URLSearchParams();
                postvars.append('ep', 'appointment');
                postvars.append('data', '[' + JSON.stringify(formValid["postdata"]) + ']');
                // post to gateway
                axios.post(this.apiHost, postvars)
                .then(function(response) {
                    console.log("Send mail response :" + JSON.stringify(response.data));
                    // alert("Your email was sent");
                    par.sent = true;
                    // par.hideProductAction();
                    // this.renderModal(window.curStrings["appointment_sent"]); 
                    par.scrollToTop();                 
                })
                .catch(function (error) {
                    console.log("Sending mail failed :" + error);
                    console.log(error);
                })

            } else {
                alert(formValid["msg"]);
            }
        },
        validateForm() {
            var result = Array();
            result["status"] = "success";
            var email = document.getElementById("customer_email").value;
            var name = document.getElementById("customer_name").value;
            var phone = document.getElementById("customer_phone").value;
            // var chassis_number = document.getElementById("customer_chassisno").value;
            var platevin = document.getElementById("customer_platevin").value;
            var city = document.getElementById("shipping_city").value;
            var country = document.getElementById("shipping_country").value;
            var customer_notes = document.getElementById("customer_notes").value;
            var customer_prefloc = document.getElementById("customer_prefloc").value;
            // billing
            var missingFields = "Please fill in the fields: \n";
              if(name == "") {
                result["status"] = "failed";
                missingFields += "Please enter your name \n";
            }
            if(city == "") {
                result["status"] = "failed";
                missingFields += "Please your city \n";
            }
            if(country == "") {
                result["status"] = "failed";
                missingFields += "Please your country \n";
            }
            if(phone == "") {
                result["status"] = "failed";
                missingFields += "Please enter your phone number # \n";
            }            
            if(email == "") {
                result["status"] = "failed";
                missingFields += "Please enter a valid email address \n";
            } 

            if(platevin == "") {
                result["status"] = "failed";
                missingFields += "Please enter License plate or VIN \n";
            } 
          
            var postData = {};
            postData["name"] = name; 
            postData["city"] = city; 
            postData["country"] = country; 
            postData["phone"] = phone; 
            postData["email"] = email; 
            postData["platevin"] = platevin; 
            postData["selectedMake"] = this.$store.state.curSelectedMake; 
            postData["selectedModel"] = this.$store.state.curSelectedModel; 
            postData["selectedVariant"] = this.$store.state.curSelectedVariant; 
            var fullDescription = this.fullSelectionDesc();
            postData["vehicleDetails"] = fullDescription; 
            postData["productDetails"] = this.$store.state.curSelectedProduct.Category; 
            postData["customer_prefloc"] = customer_prefloc; 
            postData["question"] = customer_notes; 
            postData["language"] = this.$i18n.locale; 
            postData["hostDomain"] = this.$store.state.hostDomain;             
            

            result["msg"] = missingFields;
            result["postdata"] = postData;
            return result;
        }
    },
    mounted() {
    var par = this;

    this.scrollToTop();
    
    console.log("mounted-> countries:" );
        var countriesURL = this.apiHost+"?ep=countries";
        axios.get(countriesURL )
        .then(function(response) {
            console.log("response: " + JSON.stringify(response.data));
            par.countries = response.data
        })
        .catch(function (error) {
            console.log(error);
        })
    }
}

</script>

<style>

</style>